import React, { useEffect, useState } from "react";
import ViewComponent from "components/containers/dashboard/dataEps/ViewComponent";
import { useDispatch } from "react-redux";
import {
  dEpsClearStateAC,
  dEpsSetDataSagaAC,
  dEpsSetDetailsTerminalsItemAC,
} from "model/dashboardEPS/dEpsActionCreators";
import { Trans } from "@lingui/macro";
import { typeDataOrdersInfoBulkActions } from "components/containers/dashboard/dataOrders";
import { typeEpsTableDataItem } from "model/dashboardEPS/dEpsReducer";

export type typeDataEps = {
  variant?: string;
};
export type typeDataEpsRowActions = {
  id: string;
  title: JSX.Element;
  action: (item: typeEpsTableDataItem) => void;
}[];
export type typePopupMode = "bulk" | "single";

export const DataEps: React.FC<typeDataEps> = ({ variant }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(dEpsSetDataSagaAC());

    return () => {
      dispatch(dEpsClearStateAC());
    };
    // eslint-disable-next-line
  }, []);

  // popups
  const [openDetailsEpsPopup, setOpenDetailsEpsPopup] = useState(false);
  const [openConnectEpsPopup, setOpenConnectEpsPopup] = useState(false);
  const [openDisconnectEpsPopup, setOpenDisconnectEpsPopup] = useState(false);
  const [openBulkDisconnectEpsPopup, setOpenBulkDisconnectEpsPopup] =
    useState(false);
  const [popupMode, setPopupMode] = useState<typePopupMode>("single");

  // Make table item actions
  const rowsActions = [
    {
      id: "Disconnect",
      title: <Trans>Disconnect eps</Trans>,
      action: (item: typeEpsTableDataItem) => {
        dispatch(dEpsSetDetailsTerminalsItemAC(item));
        setPopupMode("single");
        setOpenDisconnectEpsPopup(true);
      },
    },
    {
      id: "Connect",
      title: <Trans>Connect eps</Trans>,
      action: (item: typeEpsTableDataItem) => {
        dispatch(dEpsSetDetailsTerminalsItemAC(item));
        setPopupMode("single");
        setOpenConnectEpsPopup(true);
      },
    },
  ];

  // Make bulk actions
  const bulkActions: typeDataOrdersInfoBulkActions = [
    {
      title: <Trans>Connect selected terminals to eps</Trans>,
      action: () => {
        setPopupMode("bulk");
        setOpenConnectEpsPopup(true);
      },
    },
    {
      title: <Trans>Disconnect selected terminal from eps</Trans>,
      action: () => {
        setPopupMode("bulk");
        setOpenBulkDisconnectEpsPopup(true);
      },
    },
  ];
  return (
    <ViewComponent
      variant={variant}
      openConnectEpsPopup={openConnectEpsPopup}
      setOpenConnectEpsPopup={setOpenConnectEpsPopup}
      openDisconnectEpsPopup={openDisconnectEpsPopup}
      setOpenDisconnectEpsPopup={setOpenDisconnectEpsPopup}
      openBulkDisconnectEpsPopup={openBulkDisconnectEpsPopup}
      setOpenBulkDisconnectEpsPopup={setOpenBulkDisconnectEpsPopup}
      openDetailsEpsPopup={openDetailsEpsPopup}
      setOpenDetailsEpsPopup={setOpenDetailsEpsPopup}
      bulkActions={bulkActions}
      rowsActions={rowsActions}
      popupMode={popupMode}
    />
  );
};
